<template>
    <div class="container px-5 mx-auto mt-32 mb-5 md:max-w-6xl">
        <img src="/img/page_not_found.svg" alt="" class="w-full h-96">
        <a class="flex justify-center mt-5 text-center underline" href="/">Return Home </a>
    </div>
</template>